import React from "react";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';



import {
  makeStyles,
} from "@material-ui/core";

const schema = yup.object().shape({
  first_name: yup.string(),
  last_name: yup.string(),
  address: yup.string(),
  contact_number: yup.string(),
  email: yup.string(),
  date_of_birth: yup.string(),
  occupation: yup.string(),
});

const useStylesAll = makeStyles(theme => ({
  description: {
    '& ul': {
      marginTop: 0,
      color: "#666666",
      marginLeft: "15px",
    },
  },
  price: {
    textAlign: "right",
  },
  disabled: {
    color: "rgba(0, 0, 0, 0.38)",
  },
  discounted: {
    color: "#962013",
    marginLeft: "5px",
  },
  notOriginal: {
    textDecoration: "line-through",
    [theme.breakpoints.down('sm')]: {
      float: "right",
      position: "absolute",
      top: "30px",
      right: 0,
    },
  },
}));



function RegisterStep2Page(props) {
  const { currentStep, handleChange, plan, planList, renewalDiscount, isPromotionPeriod } = props;
  // const defaultFormValues = {
  //   plan: plan,
  // };
  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  // const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const history = useHistory();

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
    // defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  const onSubmit = async (value) => {
    // setLoading(true);
    // purge date and time
    const { date, time, ...data } = value;
    try {
      // TODO: update 
      // value
    } catch (e) {
      console.log(e);
    }
    // setLoading(false);
  };

  const getRegisterInfo = React.useCallback(async () => {
    try {
      // setLoading(true);
      // var newDefaultFormValues = defaultFormValues;
      // setDefaultValues(newDefaultFormValues);
      // reset(newDefaultFormValues);
    } catch (err) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  }, []);

  function PriceBox(props) {
    const { price, discounted } = props;
    return (
      <>
        <Typography variant="span" className={discounted ? classes.notOriginal : ''}>{t('hkd')}{price}{discounted ? '' : `/${t('year')}`}</Typography>
        { discounted ? <Typography variant="span" className={classes.discounted}>{t('hkd')}{discounted}/{t('year')}</Typography> : <></>}
      </>
    );
  };

  function PlanOption(props) {
    const { id, name, price, details, renewalDiscount } = props;
    var discounted = "";
    if(renewalDiscount != ""){
      discounted = parseFloat(price) - parseFloat(renewalDiscount)
    }
    var priceint = parseInt(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (
      <Grid container direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item xs sm={6}>
          <FormControlLabel value={id} control={<Radio checked={plan == id} />} label={name} />
        </Grid>
        <Grid item xs sm={6} className={classes.price}>
          <PriceBox price={priceint} discounted={discounted} />
        </Grid>
        { plan == id ?
          <Grid item xs={12} className={classes.description}>
            <ul>
            {details && Object.keys(details).map(function (key) {
              return details[key] && (
                <li>
                {details[key]['value']}
                </li>
              )
            })}
            </ul>
          </Grid>
          : <></>
        }
      </Grid>
    );
  };

  React.useEffect(() => {
    getRegisterInfo();
  }, [getRegisterInfo]);

  return (
    currentStep == 2 ?
      <>
        <Grid container spacing={1}>
          <Grid item xs={12}>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h2" style={{ marginBottom: 0 }}>{t('pleasechooseplan')}</Typography>
              </Grid>
              <Grid item xs={12}>
                <FormControl component="fieldset" style={{ width: "100%", marginTop: 0 }}>
                  <RadioGroup aria-label="plan" name="plan" value={plan} onChange={handleChange}>
                    {Object.keys(planList).map(function (key) {
                      return (
                        <PlanOption id={planList[key]['id']} name={planList[key]['name']} details={planList[key]['detail']} price={planList[key]['price']} renewalDiscount={(isPromotionPeriod && (planList[key]['name'] === 'Classic' || planList[key]['name'] === '會員')) ? renewalDiscount : ""} />
                      )
                    })}
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
      : <></>
  );
}

export default RegisterStep2Page;
